import { inject, Injectable, signal } from '@angular/core';
import { IDataPayloadMultiple } from 'src/app/core/http/http.interface';
import { QsHttpService } from 'src/app/core/http/qs-http.service';
import { Observable, of, tap } from 'rxjs';
import { TTopicAppLink } from './sub-menu-app-solutions.interface';

@Injectable({
  providedIn: 'root'
})
export class SubMenuAppSolutionsService {
  protected readonly _http: QsHttpService = inject(QsHttpService);

  topicApps$ = signal<IDataPayloadMultiple<TTopicAppLink> | null>(null);

  getTopicApps(): Observable<IDataPayloadMultiple<TTopicAppLink>> {
    const params = [
      'fields=slug',
      'fields=name',
      'sort=name:ASC',
    ];

    if (this.topicApps$()) {
      return of(this.topicApps$()!);
    }

    return this._http.get<IDataPayloadMultiple<TTopicAppLink>>(`/app-topic-pages?${params.join('&')}`)
      .pipe(
        tap((response) => this.topicApps$.set(response)),
      );
  }
}
